import React, { Fragment } from 'react';
import NumberFormat from 'react-number-format';
import { setRate } from './setRate';
import { roundCurrency } from '../../../util/currency';

export default ({
  SOIID,
  Currency = 'USD',
  Quantity,
  Discount,
  Amount,
  ProductCode,
  Model,
  Color,
  Voltage,
  HDD,
  SSD,
  Item,
  AACost,
  USDRetail,
  KRWRetail,
  Description,
  HS_CODE,
  index,
  serials,
  customDescription,
  isShowDiscount,
  sku,
  company,
  billingCountry,
  rate,
  Rate,
}) => {
  Currency = Currency == null ? 'USD' : Currency;

  // 우선순위: 화면에서 넘겨준 rate > 주문에 저장된 단가(Rate) > 상품의 현재 정가.
  // 정가는 연 1회 개정되므로 저장된 단가가 있으면 그것을 써야 옛 주문 PDF의
  // List Price가 개정된 가격으로 바뀌지 않는다.
  const effectiveRate =
    typeof rate !== 'undefined'
      ? rate
      : Rate != null
        ? Rate
        : setRate(
            {
              AACost,
              USDRetail,
              KRWRetail,
            },
            Currency,
            company,
            billingCountry
          );

  return (
    <tr>
      <td>{index + 1}</td>
      <td>
        <p className="SalesOrderPDF__Article--ProductName">
          {ProductCode.trim()}
        </p>
        {Model.trim() == 'CS_Parts' ? (
          <p className="SalesOrderPDF__Article--ProductDescription">
            {sku ? sku : `${Model.trim()}-${Item != null ? Item.trim() : ''}`}-
            {Description == undefined ? '' : Description.trim()}
            {Description == undefined || HS_CODE == undefined ? '' : ' / '}
            {HS_CODE == undefined ? '' : HS_CODE.trim()}
          </p>
        ) : (
          <p className="SalesOrderPDF__Article--ProductDescription">
            {sku
              ? sku
              : `${Model.trim()}-${Color.trim()}-${Voltage.trim()}-${HDD.trim()}-${SSD.trim()}`}
            -{Description == undefined ? '' : Description.trim()}
            {Description == undefined || HS_CODE == undefined ? '' : ' / '}
            {HS_CODE == undefined ? '' : HS_CODE.trim()}
          </p>
        )}
        <p className="SalesOrderPDF__Article--ProductDescription">
          {serials == undefined
            ? ''
            : serials.map((serial) => serial.Serial).join(', ')}
        </p>
        <p className="SalesOrderPDF__Article--ProductDescription">
          {customDescription == undefined ? '' : customDescription}
        </p>
      </td>
      <td>{Quantity}</td>
      {isShowDiscount ? (
        <Fragment>
          <td>
            <NumberFormat value={effectiveRate * Quantity} />
          </td>
          <td>{Math.floor(Discount)}%</td>
        </Fragment>
      ) : (
        <Fragment>
          <td>
            <NumberFormat
              value={roundCurrency(Amount / Quantity, Currency)}
              displayType={'text'}
              thousandSeparator={true}
              prefix={Currency.trim() == 'KRW' ? '₩' : '$'}
            />
          </td>
        </Fragment>
      )}
      <td>
        <NumberFormat
          value={Amount}
          displayType={'text'}
          thousandSeparator={true}
          prefix={Currency.trim() == 'KRW' ? '₩' : '$'}
        />
      </td>
    </tr>
  );
};
